import { EventConfig, EventFactory } from './eventFactory.interface';
import { ISemanticEvent } from './semanticEvent.interfcace';

const createName = (...args: (string | undefined)[]) => args.filter(Boolean).join('-');
export const createSemanticName = (event: Pick<ISemanticEvent, 'subject' | 'object' | 'action' | 'result'>) =>
  createName(event.subject, event.action, event.object, event.result);

/**
 * function creates factory for semantic events
 * @param params default event params or name
 * @param mapper function to transform event payload
 * @return SemanticEvent factory
 */
export const createEventFactory = <T = void, M = T>(params: EventConfig, mapper?: (payload: M) => T): EventFactory<T, M> => {
  const name = createSemanticName(params);
  const eventFactory = (payload: M) => {
    const event = {
      name,
      timestamp: Date.now(),
      ...params,
      payload: mapper ? mapper(payload as M) : (payload as unknown as T),
    };
    Object.defineProperties(event, {
      [Symbol.toPrimitive]: {
        enumerable: false,
        value: () => `${event.timestamp}: ${event.name}`,
      },
    });
    return event;
  };
  eventFactory.eventName = name;
  return eventFactory;
};
